import React from 'react';
import Spinner from '@atlaskit/spinner';
function getSpinnerAppearance(_ref) {
  var appearance = _ref.appearance,
    isDisabled = _ref.isDisabled,
    isSelected = _ref.isSelected;
  if (isDisabled) {
    return 'inherit';
  }
  if (isSelected) {
    return 'invert';
  }
  if (appearance === 'primary' || appearance === 'danger') {
    return 'invert';
  }
  return 'inherit';
}
export default function LoadingSpinner(_ref2) {
  var appearance = _ref2.appearance,
    isDisabled = _ref2.isDisabled,
    isSelected = _ref2.isSelected,
    _ref2$spacing = _ref2.spacing,
    spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
  var size = spacing === 'default' ? 'medium' : 'small';
  return /*#__PURE__*/React.createElement(Spinner, {
    size: size,
    label: ", Loading",
    appearance: getSpinnerAppearance({
      appearance: appearance,
      isDisabled: isDisabled,
      isSelected: isSelected
    })
  });
}